// this needs to be the first import since it determines the cdn location of resources
import "./publicPath.ts";

import * as Sentry from "@sentry/browser";
import "./helpers/nodelist-foreach-polyfill";
import "./i18n/i18n";
import BlogImageSwiper from "./components/swipers/blogImageSwiper";
import ProductSwiper from "./components/swipers/productSwiper";
import BwareSwiper from "./components/swipers/bwareSwiper";
import {ShopRatingHandler} from "./components/ShopRating/shopRatingHandler";
import PinitComponent from "./components/pinitComponent";
import {init as initCart} from "./index-cart";
import EnergyLabelPortal from "./components/energyLabel/EnergyLabelPortal";
import NewsletterRegistrationPagePortal from "./components/newsletter/NewsletterRegistrationPagePortal";
import {ProductBundleHandler} from "./components/ProductView/PdpBundle";
import {beforeBreadcrumb, beforeSend} from "./helpers/sentryHelper";
import BlogOverviewSwiper from "./components/organisms/blog/BlogOverviewSwiper";
import PayPalPayLaterMessagePortal from "./components/lib/Banner/PayPalPayLaterMessage";
import SubNavImageLinkPortal from "./components/molecules/SubNavImageLink";
import {SwiperElementType} from "./components/molecules/SwiperTypes";
import AdvantageBannerAutoplayer from "./components/swipers/AdvantageBannerAutoplayer";
import GeoLocationModalPortal from "./components/lib/ModalWindow/GeoLocationModal";
import GiftBlockPortal from "./components/giftBlock/GiftBlockPortal";
import {submitFormToShopApi} from "./typescript-library/account/accountFormSubmit";

Sentry.init({
  dsn: "https://17a766be243d431cb89d9487d11259fe@sentry.io/1299670",
  enabled: __PRODUCTION__ || !!new URLSearchParams(window.location.search).get("sentry"),
  normalizeDepth: 5,
  beforeBreadcrumb,
  beforeSend,
});

if (__DEVELOPMENT__) {
  // eslint-disable-next-line no-console
  console.log("%cDevelopment", "color: red; font-size: x-large;");
}

initCart();

// Product slider in blog entries and in longtext (TextPlaceholder)
const swiperProductsRedesign: NodeListOf<HTMLDivElement> = document.querySelectorAll(".swiper-products-redesign");

const topAdvantagesBanner = document.body.querySelector<SwiperElementType>(
  ".vorteile-banner swiper-container.advantage-banner--swiper",
);
if (topAdvantagesBanner) {
  new AdvantageBannerAutoplayer(topAdvantagesBanner);
}

if (swiperProductsRedesign.length > 0) {
  swiperProductsRedesign.forEach((swiper) => {
    BlogImageSwiper.run({swiperDiv: swiper, clickedTracking: "BlogEntry.ProductSwiper.Slide.Clicked"});
  });
}

// Blog images, Coverflow style
const swiperBlogImages: NodeListOf<HTMLDivElement> = document.querySelectorAll(".swiper-blog-images");
if (swiperBlogImages.length > 0) {
  swiperBlogImages.forEach((swiper) => {
    BlogImageSwiper.run({swiperDiv: swiper, clickedTracking: "BlogEntry.ImageSwiper.Slide.Clicked"});
  });
}

// Initialisierung Swiper Produktseiten
const swiperContainerProduct = document.body.querySelector<HTMLDivElement>(".swiper-container-product");
if (swiperContainerProduct !== null) {
  new ProductSwiper(swiperContainerProduct);
}

// Initialisierung Swiper Blog-Einträge - Galerie
const gallerySwiper: HTMLDivElement | null = document.querySelector(".swiper-container-gallery");
if (gallerySwiper !== null) {
  BlogImageSwiper.run({swiperDiv: gallerySwiper, swipedTracking: "BlogGallerySwiper.Swiped"});
}

// Alle Swiper B-Waren-Seite
const galleryLinkCollection = document.querySelectorAll<HTMLAnchorElement>(".gallery-link");
if (galleryLinkCollection.length > 0) {
  BwareSwiper.run(galleryLinkCollection);
}

// Asynchronous shoprating loading
const shopRatingElement: HTMLElement | null = document.querySelector("[data-react-rating]");
const headlineRating: HTMLElement | null = document.querySelector(".product-rating");
if (shopRatingElement) {
  ShopRatingHandler.run(shopRatingElement, headlineRating);
}

const blogEntryContentElement = document.querySelector<HTMLElement>(".blog-entry__content");
if (blogEntryContentElement) {
  PinitComponent.pinit(blogEntryContentElement, {
    minHeight: 200,
    minWidth: 200,
  });
}

const newsletterRegistrationPage = document.getElementById("newsletter-landing-page");
if (newsletterRegistrationPage) {
  NewsletterRegistrationPagePortal.run(newsletterRegistrationPage);
}

const energyLabelElements = document.querySelectorAll<HTMLElement>("[data-energy-class]");
if (energyLabelElements.length) {
  EnergyLabelPortal.run(energyLabelElements);
}

const productBundleContainer = document.getElementById("product-bundle-container");
if (productBundleContainer) {
  ProductBundleHandler.run(productBundleContainer as HTMLDivElement);
}

const rootBlogOverviewSection: HTMLElement | null = document.querySelector("#blogOverviewPlaceholder");
if (rootBlogOverviewSection) {
  BlogOverviewSwiper.run(rootBlogOverviewSection);
}

// Highlights & Aktionen
const redesignHomepageBannerSection: HTMLElement | null = document.querySelector("#BannerSection");
if (redesignHomepageBannerSection) {
  BlogImageSwiper.run({
    swiperDiv: redesignHomepageBannerSection as HTMLDivElement,
    swipedTracking: "Homepage.HomepageBannerSwiper.Swiped",
    looped: false,
  });
  // HomepageBannerSwiper.run(redesignHomepageBannerSection);
}

// Print item as gift card component
const giftBlockContainer: HTMLDivElement | null = document.querySelector("#ProductGiftBlock");
if (giftBlockContainer) {
  GiftBlockPortal.run(giftBlockContainer);
}

PayPalPayLaterMessagePortal.run();

SubNavImageLinkPortal.run();

GeoLocationModalPortal.run();

// Before sending the user account forms which updates the addresses in the ecs,
// we need to change the address in existing checkoutAddress and customerAddress tables in the shop db.
const CustomerInvoiceAddressForm = document.getElementById("CustomerInvoiceAddressForm");
const CustomerDeliveryAddressForm = document.getElementById("CustomerDeliveryAddressForm");

if (CustomerInvoiceAddressForm) {
  CustomerInvoiceAddressForm.addEventListener("submit", submitFormToShopApi);
}
if (CustomerDeliveryAddressForm) {
  CustomerDeliveryAddressForm.addEventListener("submit", submitFormToShopApi);
}
